module.exports = __webpack_public_path__ + "static/img/news0930c.da0c569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/news0930c.jpg
// module id = G7tY
// module chunks = 1